import { useMemo } from "react";
import { useAccessToken } from "shared-ts-utils-authentication";
import { CustomerSettingsDao } from "./CusomerSettingsDao";
import { useCustomerEnvironmentNameOrThrow } from "firefly-shared-ts-customer-environment";

export const useCustomerSettingsDao = (): CustomerSettingsDao => {
  const accessToken = useAccessToken();
  const customerEnvironmentName = useCustomerEnvironmentNameOrThrow();
  return useMemo(
    () =>
      new CustomerSettingsDao({
        accessToken: accessToken,
        customerEnvironment: customerEnvironmentName,
      }),
    [customerEnvironmentName, accessToken]
  );
};
